import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { loadingReset, loadingUpdate } from '../store/actions/loadingAction'

export const useLoading = () => {
  const dispatch = useDispatch()

  const showLoading = useCallback(() => {
    dispatch(loadingUpdate(true))
  }, [dispatch])

  const hideLoading = useCallback(() => {
    dispatch(loadingReset())
  }, [dispatch])

  /**
   * Wrapper para executar uma função assíncrona com loading automático
   * @param fn Função assíncrona a ser executada
   * @returns Resultado da função
   */
  const withLoading = useCallback(
    async <T>(fn: () => Promise<T>): Promise<T> => {
      showLoading()
      try {
        return await fn()
      } finally {
        hideLoading()
      }
    },
    [showLoading, hideLoading]
  )

  return {
    showLoading,
    hideLoading,
    withLoading
  }
}
